<template>
  <div>
    <h2>
      Label
    </h2>
    <el-form
      ref="form"
      v-loading="isSaving"
      :rules="rules"
      :model="formData"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="Label Template"
            prop="labelTemplate"
          >
            <el-input
              v-model="formData.labelTemplate"
              placeholder="generic.label"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Consignment Note Template"
            prop="template"
          >
            <el-input
              v-model="formData.template"
              placeholder="generic.con"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item
            label="Print Connote"
            prop="printConnote"
          >
            <el-switch v-model="formData.printConnote" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Print Label"
            prop="printLabel"
          >
            <el-switch v-model="formData.printLabel" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
      default: null
    }
  },
  data () {
    return {
      rules: {
        labelTemplate: [
          { required: true, message: 'Label Template is required', trigger: ['blur'] }
        ],
        template: [
          { required: true, message: 'Template is required.', trigger: ['blur'] }
        ]
      },
      isSaving: false
    }
  }
}
</script>
